import React, { Fragment } from 'react';
// import { useQuery } from '@apollo/react-hooks';
// import { gql } from 'apollo-boost';
import { Link } from 'react-router-dom';
import Header from '../components/header';
import Footer from '../components/footer';
// import shoe from '../assets/gal-2.jpeg';
// import Spinner from 'react-spinkit';
// import { from } from 'apollo-boost';

// const CATEGORIES = gql`
//   query CATEGORIES{
//     categories{
//       id
//       name
//     }
//   }
// `;

const Index = () => {

  // const { loading, error, data } = useQuery(CATEGORIES);
  // if (loading) return (<Spinner name="circle" />);
  // {console.log(data.categories)}
    return (
      <Fragment>
        <Header />
          <div className="container">
            <section className="hero">
              <h2 className="hero__heading">Only the best items you can find</h2>
              <button className="btn hero__btn"><Link to="/category/all" >Shop By Category</Link></button>
            </section>
            <section className="categories">


              <div className="categories__one">
                <h3 className="categories__header">Shoes</h3>
                <button className="btn categories__btn"><Link to="/category/5fc91bb4b502b500244a3d67">Shop Now</Link></button>
              </div>
              <div className="categories__two">
                <h3 className="categories__header">Clothings</h3>
                <button className="btn categories__btn"><Link to="/category/5fc927a11586da002426bbf0">Shop Now</Link></button>
              </div>
              <div className="categories__three">
                <h3 className="categories__header">
                  Bags
                </h3>
                <button className="btn categories__btn"><Link to="/category/5fc927861586da002426bbef">Shop Now</Link></button>
              </div>

              {/* <div className="categories__four">
                <h3 className="categories__header">
                  Sneakers
                </h3>
                <button className="btn categories__btn"><Link to="/category/5ece33f15d746d320c87f42f">Shop Now</Link></button>
              </div>
              <div className="categories__five">
                <h3 className="categories__header">
                  Shades
                </h3>
                <button className="btn categories__btn"><Link to="/category/5ece33fc5d746d320c87f430">Shop Now</Link></button>
              </div>
              <div className="categories__six">
                <h3 className="categories__header">
                  General
                </h3>
                <button className="btn categories__btn"><Link to="/category/5ece34075d746d320c87f431">Shop Now</Link></button>
              </div>
             */}
            </section>

            {/* <section className="products">
              <h2>Best Seller Products</h2>
              <div className="products__card">
                <figure>
                  <img src={shoe} alt="" className="products__img" />
                </figure>
                <p className="products__name">Bose Headphones</p>
                <p className="products__price">$230</p>
                <button className="btn products__btn">Add To Cart</button>
              </div>
              <div className="products__card">
                <figure>
                  <img src={shoe} alt="" className="products__img" />
                </figure>
                <p className="products__name">Bose Headphones</p>
                <p className="products__price">$230</p>
                <button className="btn products__btn">Add To Cart</button>
              </div>
              <div className="products__card">
                <figure>
                  <img src={shoe} alt="" className="products__img" />
                </figure>
                <p className="products__name">Bose Headphones</p>
                <p className="products__price">$230</p>
                <button className="btn products__btn">Add To Cart</button>
              </div>
              <div className="products__card">
                <figure>
                  <img src={shoe} alt="" className="products__img" />
                </figure>
                <p className="products__name">Bose Headphones</p>
                <p className="products__price">$230</p>
                <button className="btn products__btn">Add To Cart</button>
              </div>
            </section> */}

          </div>
        <Footer />
      </Fragment>
    )
}

export default Index;